import { Box, Button, Heading, Image, Stack, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import MainLayout from '../../components/layout/MainLayout';
import { useRouteHelper } from '../../hooks/routesHelpers';

export default function Page404() {
  const { t } = useTranslation();
  const history = useHistory();
  const { setRoute } = useRouteHelper();
  const homePage = setRoute('home');
  return (
    <MainLayout smallPadding title={t('landingPage.seoTitle')} description={t('landingPage.seoDescription')}>
      <Stack align="center" textAlign="center" justifyContent="center">
        <Box>
          <Image
            className="lazyload"
            width={{ base: '80px', md: '100px' }}
            objectFit="cover"
            src="/assets/character/surprised_purple.svg"
            alt="Flate"
          />
        </Box>
        <Heading>{t('pageNotFound.title')}</Heading>
        <Text>{t('pageNotFound.message')}</Text>
        <Button onClick={() => history.push(homePage)} variant="link" colorScheme="brand">
          {t('pageNotFound.ctaLabel')}
        </Button>
      </Stack>
    </MainLayout>
  );
}
